import { useTranslations } from 'next-intl';
import { cn } from '@lib/utils';

export default function DayBadge({
  day,
  className,
}: {
  day: number;
  className?: string;
}) {
  const t = useTranslations('TenYears.stories');
  return (
    <span
      className={cn(
        'rounded-full bg-[#ff8c98] px-4 py-[3px] text-[14px] font-semibold leading-[22px] tracking-[-0.128px] text-white',
        className,
      )}
    >
      {t('dayBadge', { day })}
    </span>
  );
}
